import type { NodeType } from './schemas/common.ts';

// Where a node's page is. The SPA links to it (src/navigation.ts re-exports
// these) and the Worker writes the same address into a label's QR code and
// the labels CSV, so a printed code opens the page the app would.

const SEGMENTS: Readonly<Record<NodeType, string>> = {
  client: 'clients',
  property: 'properties',
  room: 'rooms',
  rack: 'racks',
  item: 'items',
  drop: 'drops',
};

/** The plural path segment a node type uses in pages and API paths. */
export function nodeSegment(type: NodeType): string {
  return SEGMENTS[type];
}

/** Canonical page for a node. */
export function nodeHref(type: NodeType, id: string): string {
  return `/${nodeSegment(type)}/${id}`;
}

/** A property's photo timeline (ROADMAP L2): every photo under it in time order. */
export function photoTimelineHref(propertyId: string): string {
  return `/properties/${propertyId}/photos`;
}
